module.exports = "<a href=\"javascript:void(0)\"\n  class=\"btn btn-link\"\n  (click)=\"handleClick($event)\">\n  {{ record[model] }}\n</a>";